exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sw-survey-container{display:flex;width:100%;height:100%}.sw-width-full{width:100%}.sw-mx-auto{margin:auto}", ""]);

// exports
